import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Checkbox (MUI-`Checkbox`-Ersatz) — native Checkbox mit Marken-`accent-color`. */
export const Checkbox = forwardRef(function Checkbox({ className, ...rest }, ref) {
    return _jsx("input", { ref: ref, type: "checkbox", className: cn('sec-checkbox', className), ...rest });
});
